/**
 * 主提单状态枚举
 * マスター提单ステータス列挙
 * Master Bill Status Enum
 */
export enum MasterBillStatus {
  PENDING_CONFIRMATION = 'PENDING_CONFIRMATION',
  AWAITING_DEVAN = 'AWAITING_DEVAN',
  DEVANNING = 'DEVANNING',
  MOVED_IN = 'MOVED_IN',
  MOVED_OUT_FINAL = 'MOVED_OUT_FINAL'
}

/**
 * 主提单状态显示名称映射
 * マスター提单ステータス表示名マッピング
 * Master Bill Status Display Names
 */
export const MasterBillStatusDisplay: Record<MasterBillStatus, string> = {
  [MasterBillStatus.PENDING_CONFIRMATION]: '待确认',
  [MasterBillStatus.AWAITING_DEVAN]: '待拆柜',
  [MasterBillStatus.DEVANNING]: '拆柜中',
  [MasterBillStatus.MOVED_IN]: '已搬入',
  [MasterBillStatus.MOVED_OUT_FINAL]: '已搬出'
}

/**
 * 获取主提单状态的显示名称
 * マスター提单ステータスの表示名を取得
 * Get Master Bill Status Display Name
 */
export const getMasterBillStatusDisplay = (status: MasterBillStatus): string => {
  return MasterBillStatusDisplay[status] || status
}

/**
 * 分提单状态枚举
 * ハウス提单ステータス列挙
 * House Bill Status Enum
 */
export enum HouseBillStatus {
  PENDING_INBOUND = 'PENDING_INBOUND',
  UNDER_REVIEW = 'UNDER_REVIEW',
  PENDING_OUTBOUND = 'PENDING_OUTBOUND',
  PENDING_INSPECTION = 'PENDING_INSPECTION',
  UNDER_INSPECTION = 'UNDER_INSPECTION',
  PENDING_CONFIRMATION = 'PENDING_CONFIRMATION',
  OUTBOUND_IN_PROGRESS = 'OUTBOUND_IN_PROGRESS',
  PENDING_DELIVERY = 'PENDING_DELIVERY',
  COMPLETED = 'COMPLETED'
}

/**
 * 分提单状态显示名称映射
 * ハウス提单ステータス表示名マッピング
 * House Bill Status Display Names
 */
export const HouseBillStatusDisplay: Record<HouseBillStatus, string> = {
  [HouseBillStatus.PENDING_INBOUND]: '待入库',
  [HouseBillStatus.UNDER_REVIEW]: '审核中',
  [HouseBillStatus.PENDING_OUTBOUND]: '待出库',
  [HouseBillStatus.PENDING_INSPECTION]: '待查验',
  [HouseBillStatus.UNDER_INSPECTION]: '查验中',
  [HouseBillStatus.PENDING_CONFIRMATION]: '待确认',
  [HouseBillStatus.OUTBOUND_IN_PROGRESS]: '搬出中',
  [HouseBillStatus.PENDING_DELIVERY]: '待配送',
  [HouseBillStatus.COMPLETED]: '已出库'
}

/**
 * 获取分提单状态的显示名称
 * ハウス提单ステータスの表示名を取得
 * Get House Bill Status Display Name
 */
export const getHouseBillStatusDisplay = (status: HouseBillStatus): string => {
  return HouseBillStatusDisplay[status] || status
}

/**
 * 托盘状态枚举
 * パレットステータス列挙
 * Pallet Status Enum
 */
export enum PalletStatus {
  PENDING = 'pending',      // 待入库
  STORED = 'stored',        // 已入库
  DELIVERY = 'delivery',    // 待发货
  SHIPPED = 'shipped'       // 已出库
}

/**
 * 托盘状态显示名称映射
 * パレットステータス表示名マッピング
 * Pallet Status Display Names
 */
export const PalletStatusDisplay: Record<PalletStatus, string> = {
  [PalletStatus.PENDING]: '待入库',
  [PalletStatus.STORED]: '已入库',
  [PalletStatus.DELIVERY]: '待发货',
  [PalletStatus.SHIPPED]: '已出库'
}

/**
 * 获取托盘状态的显示名称
 * パレットステータスの表示名を取得
 * Get Pallet Status Display Name
 */
export const getPalletStatusDisplay = (status: PalletStatus): string => {
  return PalletStatusDisplay[status] || status
}

